var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppDialog',{attrs:{"open":_vm.visible,"title":"Passwort zurücksetzen","classes":"reset-password-dialog"},on:{"close":function($event){_vm.visible = false}}},[_c('ResetPasswordForm',{on:{"submit":_vm.handleSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }